import React from 'react';
const PRICE = 19;
const ORIGINAL_PRICE = 47.5;
const DISCOUNT_PERCENT = 60;
export function PricingSection() {
  const checkoutUrl = 'https://italia.digitalpack.shop/cart/54207212290323:1';
  const firePixel = () => {
    const w = window as any;
    if (w.fbq) {
      w.fbq('track', 'AddToCart', {
        content_name: 'Arte Pronta Kit',
        content_type: 'product',
        value: PRICE,
        currency: 'EUR'
      });
    }
  };
  return <section id="pricing" className="w-full bg-bg-dark py-12 sm:py-28 px-4 sm:px-6 relative overflow-hidden" data-id="element-316">
      {/* Background Glows */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(234,88,12,0.08) 0%, transparent 70%)'
    }} data-id="element-317"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(16,185,129,0.08) 0%, transparent 70%)'
    }} data-id="element-318"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-319">
        <h2 className="text-2xl sm:text-6xl font-black text-text-main text-center mb-5 sm:mb-16 tracking-tight px-2" data-id="element-320">
          L'Offerta "ARTE PRONTA"
        </h2>

        {/* Featured Card */}
        <div className="bg-bg-alt rounded-2xl sm:rounded-3xl border border-primary/50 shadow-[0_0_50px_rgba(59,130,246,0.15)] px-4 py-6 sm:p-14 flex flex-col relative w-full sm:w-[90%] mx-auto" data-id="element-321">
          {/* Glowing Border Effect */}
          <div className="absolute inset-0 rounded-2xl sm:rounded-3xl border-2 border-transparent bg-gradient-to-b from-primary/50 to-transparent opacity-50 pointer-events-none" style={{
          maskImage: 'linear-gradient(to bottom, black, transparent)',
          WebkitMaskImage: 'linear-gradient(to bottom, black, transparent)'
        }} data-id="element-322"></div>

          <div className="absolute -top-3 sm:-top-5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-secondary to-yellow-400 text-bg-dark font-black text-[10px] sm:text-base px-4 sm:px-8 py-1 sm:py-2.5 rounded-full whitespace-nowrap shadow-[0_0_20px_rgba(245,158,11,0.5)] border border-white/20" data-id="element-323">
            ⭐ LA SCELTA PIÙ POPOLARE
          </div>

          <p className="text-xs sm:text-3xl font-black text-text-main text-center mt-2 sm:mt-4 mb-3 sm:mb-10 tracking-wide" data-id="element-324">
            VALORE TOTALE DEI CONTENUTI:
          </p>

          {/* Value list */}
          <div className="space-y-1.5 sm:space-y-5 mb-3 sm:mb-10 text-[13px] sm:text-xl" data-id="element-325">
            <div className="flex justify-between gap-2 text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-326">
              <span data-id="element-327">6 Volumi ARTE PRONTA</span>
              <span className="text-text-sec line-through flex-shrink-0" data-id="element-328">
                € 97
              </span>
            </div>
            <div className="flex justify-between gap-2 text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-329">
              <span data-id="element-330">Archivio Laboratori Creativi</span>
              <span className="text-text-sec line-through flex-shrink-0" data-id="element-331">
                € 47
              </span>
            </div>
            <div className="flex justify-between gap-2 text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-332">
              <span data-id="element-333">Toolkit Inclusione</span>
              <span className="text-text-sec line-through flex-shrink-0" data-id="element-334">
                € 37
              </span>
            </div>
            <div className="flex justify-between gap-2 text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-335">
              <span data-id="element-336">6 Bonus Esclusivi</span>
              <span className="text-text-sec line-through flex-shrink-0" data-id="element-337">
                € 90
              </span>
            </div>

            <div className="flex justify-between gap-2 text-text-main font-black pt-1 sm:pt-4 text-sm sm:text-2xl" data-id="element-338">
              <span data-id="element-339">VALORE REALE:</span>
              <span className="text-badge-red line-through" data-id="element-340">€ 271</span>
            </div>
          </div>

          {/* Price reveal */}
          <div className="text-center mb-4 sm:mb-8 bg-gradient-to-b from-primary/5 to-transparent border border-white/10 py-5 sm:py-10 rounded-xl sm:rounded-2xl relative overflow-hidden" data-id="element-341">
            <div className="absolute top-0 left-0 w-full h-0.5 sm:h-1 bg-gradient-to-r from-transparent via-primary to-transparent" data-id="element-342"></div>

            <div className="flex items-center justify-center gap-2 sm:gap-3 mb-1.5 sm:mb-4" data-id="element-343">
              <span className="text-text-sec line-through text-sm sm:text-2xl font-medium" data-id="element-344">
                € {ORIGINAL_PRICE.toFixed(2).replace('.', ',')}
              </span>
              <span className="bg-cta-green/20 text-cta-green font-black text-[10px] sm:text-sm px-2 py-0.5 sm:px-3 sm:py-1 rounded-full" data-id="element-345">
                {DISCOUNT_PERCENT}% OFF
              </span>
            </div>

            <div className="font-black text-5xl sm:text-8xl tracking-tighter transition-all leading-none text-[#FFFFFF]" data-id="element-346">
              € {PRICE}
            </div>

            <div className="text-text-sec text-[11px] sm:text-base font-medium mt-2 sm:mt-3 flex items-center justify-center gap-2" data-id="element-347">
              <span data-id="element-348">💳 Pagamento unico</span>
              <span data-id="element-349">•</span>
              <span data-id="element-350">⚡ Accesso immediato</span>
            </div>
          </div>

          <span className="inline-flex items-center justify-center gap-1.5 text-secondary font-bold text-[10px] sm:text-sm bg-secondary/10 px-3 py-1 sm:px-4 sm:py-1.5 rounded-full border border-secondary/20 animate-pulse-composited mx-auto mb-4 sm:mb-6" data-id="element-351">
            ⏰ Prezzo speciale di lancio — salirà a breve
          </span>

          {/* CTA Button */}
          <a href={checkoutUrl} onClick={firePixel} style={{
          backgroundColor: '#22C55E',
          color: '#FFFFFF',
          boxShadow: '0 0 12px rgba(34,197,94,0.25), 0 6px 18px rgba(0,0,0,0.25)'
        }} className="btn-primary-pulse block w-full text-center font-black text-lg sm:text-3xl py-5 sm:py-8 rounded-2xl border-2 border-white/30 mb-4 sm:mb-6 tracking-tight uppercase transition-transform hover:scale-[1.02] active:scale-[0.99]" data-id="element-352">
            <span className="hidden sm:inline" data-id="element-353">
              🚀 SÌ! VOGLIO IL KIT COMPLETO — € {PRICE}
            </span>
            <span className="sm:hidden" data-id="element-354">🚀 VOGLIO IL KIT — € {PRICE}</span>
          </a>

          {/* TRUST & SECURITY BADGES */}
          <div className="mt-6 sm:mt-8 pt-5 sm:pt-7 border-t border-white/10" data-id="element-355">
            {/* Trust pillars */}
            <div className="grid grid-cols-3 gap-2 sm:gap-4 mb-5 sm:mb-6" data-id="element-356">
              <div className="flex flex-col items-center text-center gap-1.5 sm:gap-2 bg-bg-dark/40 border border-white/10 rounded-xl px-2 py-3 sm:px-4 sm:py-4" data-id="element-357">
                <span className="text-2xl sm:text-3xl" aria-hidden="true" data-id="element-358">
                  🔒
                </span>
                <p className="text-white font-black text-[10px] sm:text-sm leading-tight" data-id="element-359">
                  Pagamento Sicuro
                </p>
                <p className="text-text-sec text-[9px] sm:text-xs leading-snug hidden sm:block" data-id="element-360">
                  Crittografia SSL 256-bit
                </p>
              </div>
              <div className="flex flex-col items-center text-center gap-1.5 sm:gap-2 bg-bg-dark/40 border border-white/10 rounded-xl px-2 py-3 sm:px-4 sm:py-4" data-id="element-361">
                <span className="text-2xl sm:text-3xl" aria-hidden="true" data-id="element-362">
                  🛡️
                </span>
                <p className="text-white font-black text-[10px] sm:text-sm leading-tight" data-id="element-363">
                  Garanzia 7 Giorni
                </p>
                <p className="text-text-sec text-[9px] sm:text-xs leading-snug hidden sm:block" data-id="element-364">
                  Soddisfatti o rimborsati
                </p>
              </div>
              <div className="flex flex-col items-center text-center gap-1.5 sm:gap-2 bg-bg-dark/40 border border-white/10 rounded-xl px-2 py-3 sm:px-4 sm:py-4" data-id="element-365">
                <span className="text-2xl sm:text-3xl" aria-hidden="true" data-id="element-366">
                  ✅
                </span>
                <p className="text-white font-black text-[10px] sm:text-sm leading-tight" data-id="element-367">
                  Acquisto Verificato
                </p>
                <p className="text-text-sec text-[9px] sm:text-xs leading-snug hidden sm:block" data-id="element-368">
                  +800 insegnanti soddisfatte
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}